'use client';

import { useLocale } from 'use-intl';
import NextImage from '../next-image';
import { FaPlus } from 'react-icons/fa';
import { banner_event } from '@/utils/gtm';
import NextLink from '@/components/next-link';

const CollectionCard = ({ banner, cols = 'col-span-1' }) => {
  const locale = useLocale();
  return (
    <div
      className={`relative h-[282px] overflow-hidden rounded-lg border-0 max-md:h-50 max-sm:h-38 ${cols}`}
    >
      <NextImage
        alt={banner?.title}
        src={process.env.NEXT_PUBLIC_IMG_BASEURL + banner?.image}
        className='rounded-lg'
        fill
      />
      <div className='absolute inset-0 bg-black/30' />
      <div className='relative z-10 h-full p-0 pt-0'>
        <div className='px-3 py-4 sm:p-4 md:p-8'>
          <div className='text-[13px] text-white max-sm:text-[9px] sm:mt-6'>
            {banner?.label}
          </div>
          <div className='text-base font-semibold whitespace-pre-line text-white max-sm:mt-3 max-sm:text-xs sm:mt-4 md:text-lg md:leading-7'>
            {banner?.title}
          </div>
          <NextLink
            href={banner?.href}
            onClick={() =>
              banner_event(
                process.env.NEXT_PUBLIC_IMG_BASEURL + banner?.image,
                banner?.href
              )
            }
            className='absolute bottom-5 flex items-center md:bottom-8'
          >
            <button className='me-3 flex size-5 items-center justify-center rounded-full bg-[#E53E3E26] p-0 md:h-[35px] md:w-[35px]'>
              <FaPlus className='size-3 md:!size-4' color='#FFF' />
            </button>
            <span className='text-sm font-medium text-white max-sm:text-[9px] md:text-base'>
              {locale === 'en' ? 'View Collection' : 'عرض التصنيف'}
            </span>
          </NextLink>
        </div>
      </div>
    </div>
  );
};

export default CollectionCard;
